"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valgreghentino": {
    "824a5aba": [{
      "hkey": "d67b3379",
      "slug": "valgreghentino",
      "name": "Valgreghentino",
      "primary": true,
      "skipSearch": false
    }],
    "san-giuseppe": [{
      "hkey": "d67b3379",
      "slug": "valgreghentino",
      "name": "Valgreghentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23221ffe": [{
      "hkey": "d67b3379",
      "slug": "valgreghentino",
      "name": "Valgreghentino",
      "primary": true,
      "skipSearch": false
    }],
    "villa-san-carlo": [{
      "hkey": "d67b3379",
      "slug": "valgreghentino",
      "name": "Valgreghentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;